import './wp-ticket-barcodes.scss';

import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

import { IHelpDeskService, HelpDeskSymbols, INotificationService, NotificationSymbols, ActionResult, ErrorTypes } from 'web-platform-help-desk-core-frontend-ui';

import WpBaseComponent from './../wp-base-component';
import { Ticket } from 'web-platform-help-desk-core-frontend-ui/src/HelpDesk/ticket-data';

export const wpTicketBarcodesProps = Vue.extend({
    props: {
        data: Object
    }
});

@Component({
    template: require("./wp-ticket-barcodes.html")
})
export default class WpTicketBarcode extends mixins(WpBaseComponent, wpTicketBarcodesProps, Vue) {
    protected _service!: IHelpDeskService;
    protected _notificationService!: INotificationService;

    DataTickets: Array<Ticket> = new Array<Ticket>();
    DisabledUI: boolean = false;

    created(): void {
        this._service = this.GlobalService.Get<IHelpDeskService>(HelpDeskSymbols.HelpDeskService);
        this._notificationService = this.GlobalService.Get<INotificationService>(NotificationSymbols.NotificationService);
    };

    mounted(): void {
        this.ResetRequestTicketInfo();
    };

    async ResetRequestTicketInfo(): Promise<ActionResult>{
        this.DisabledUI = true;

        this.DataTickets = new Array<Ticket>();
        let orderId = parseInt(this.data.id);
        for (let item of this.data.items) {
            if (item.status != 1 && item.status != 2 && item.haveTicket && !item.hdRefundProcess) {
                let orderItemId = parseInt(item.id);
                let token = this.data.access_token;
                let result = await this._service.GetTicketDataAsync(orderId, orderItemId, token);

                if (result.Success) {
                    result.Data!.Code = item.code;
                    result.Data!.Info = item.info;
                    result.Data!.fileName = result.Data!.fileName.split('.')[0];
                    this.DataTickets.push(result.Data!);
                } else {
                    this.DataTickets = new Array<Ticket>();
                    this._notificationService.Error('Ошибка', 'Не удалось получить информацию об элементах заказа');
                    this.DisabledUI = false;
                    return ActionResult.Failed(ErrorTypes.InternalError);
                };
            }
        };
        this.DisabledUI = false;
        return ActionResult.Success();
    }

    CloseDialog(): void {
        this.$emit("CloseDialog");
    };

    DownloadTicket(): void {
        console.info("Downloading ticket...");
    };
};

